import ApiService from '@/core/services/api.service';

const BASE_URL = 'address';

const AddressService = {
  getProvinces(search = {}) {
    return ApiService.query(`${BASE_URL}/provinces`, { params: search });
  },

  getWardsByProvince(provinceCode, search = {}) {
    return ApiService.query(`${BASE_URL}/wards`, {
      params: {
        provinceCode,
        ...search,
      },
    });
  },
};

export default AddressService;
